import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { I18nUtils } from '../../../i18n/I18nUtils';

export default class RemoveConfirmModal extends React.Component {

    buildCounter() {
        let counter = [];

        // COMPANY
        if ( this.props.countRemove && this.props.countRemove.company !== 0 ) {
            if ( this.props.countRemove.company === 1 ) {
                counter.push(<span>{this.props.countRemove.company + ' ' + I18nUtils.tr('TR_SUBCONTRATA')}</span>);
            } else {
                counter.push(<span>{this.props.countRemove.company + ' ' + I18nUtils.tr('TR_SUBCONTRATAS')}</span>);
            }
            counter.push(<br/>);
        }

        // WORKER
        if ( this.props.countRemove && this.props.countRemove.worker !== 0 ) {
            if ( this.props.countRemove.worker === 1 ) {
                counter.push(<span>{this.props.countRemove.worker + ' ' + I18nUtils.tr('TR_TRABAJADOR')}</span>);
            } else {
                counter.push(<span>{this.props.countRemove.worker + ' ' + I18nUtils.tr('TR_TRABAJADORES')}</span>);
            }
            counter.push(<br/>);
        }

        // MACHINE
        if ( this.props.countRemove && this.props.countRemove.machine !== 0 ) {
            if ( this.props.countRemove.machine === 1 ) {
                counter.push(<span>{this.props.countRemove.machine + ' ' + I18nUtils.tr('TR_MAQUINA')}</span>);
            } else {
                counter.push(<span>{this.props.countRemove.machine + ' ' + I18nUtils.tr('TR_MAQUINAS')}</span>);
            }
        }

        if ( this.props.countRemove && this.props.countRemove.company === 0
            && this.props.countRemove.worker === 0 && this.props.countRemove.machine === 0 ) {
            counter.push(<span style={{ color: 'red' }}>{I18nUtils.tr('TR_NO_EXISTEN_ELEMENTOS_PARA_ELIMINAR')}</span>);
        }
        return counter;
    }

    render() {
        const existRemoveElements = !( this.props.countRemove && this.props.countRemove.company === 0
            && this.props.countRemove.worker === 0 && this.props.countRemove.machine === 0 );

        return (
            <Modal
                {...this.props}
                bsSize="small"
                aria-labelledby="contained-modal-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-sm">{I18nUtils.tr('TR_ELIMINAR')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>{I18nUtils.tr('TR_SE_VAN_A_ELIMINAR_LOS_SIGUIENTES_ELEMENTOS')}</h4>
                    <p>{this.buildCounter()}</p>
                    {existRemoveElements &&
                        <p><small>{I18nUtils.tr('TR_SI_ELIMINA_ESTOS_ELEMENTOS_DEJARAN_DE_FORMAR_PARTE')}</small></p>}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onHide}>{I18nUtils.tr('TR_CANCELAR').toUpperCase()}</Button>
                    {this.props.countRemove.company + this.props.countRemove.worker + this.props.countRemove.machine > 0 ?
                        <Button bsStyle="danger"
                                onClick={this.props.onAccept}>{I18nUtils.tr('TR_ELIMINAR').toUpperCase()}</Button>
                        : null}
                </Modal.Footer>
            </Modal>
        );
    }
}

RemoveConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    countRemove: PropTypes.any.isRequired,
    onHide: PropTypes.func,
    onAccept: PropTypes.func,
};

RemoveConfirmModal.defaultProps = {
    countRemove: { company: 0, worker: 0, machine: 0 },
    onClose: () => {},
    onAccept: () => {},
};



// WEBPACK FOOTER //
// ./src/app/remove/components/RemoveConfirmModal.js